import React, { useState } from 'react';

import Styles from './Contato.module.scss';
import { faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';

import Header from 'components/Header/Header';

export default function Contato() {
  const { Contato } = Styles;

  const [form, setForm] = useState({
    nome: '',
    email: '',
    telefone: '',
    assunto: '',
    mensagem: '',
  });

  const onChangeHandler = e => {
    const {
      target: { name, value },
    } = e;
    setForm(x => ({ ...x, [name]: value }));
  };

  return (
    <div className={Contato}>
      <center>
        <Header icon={faEnvelopeOpen} title={'Contato'} />
      </center>
      <form>
        <p>Nome:</p>
        <input
          onChange={onChangeHandler}
          name={'nome'}
          value={form.nome}
          type='text'
        />
        <p>E-mail:</p>
        <input
          onChange={onChangeHandler}
          name={'email'}
          value={form.email}
          type='text'
        />
        <p>Telefone:</p>
        <input
          onChange={onChangeHandler}
          name={'telefone'}
          value={form.telefone}
          type='text'
        />
        <p>Assunto:</p>
        <input
          onChange={onChangeHandler}
          name={'assunto'}
          value={form.assunto}
          type='text'
        />
        <p>Mensagem:</p>
        <textarea
          onChange={onChangeHandler}
          name={'mensagem'}
          value={form.mensagem}
          rows='4'
        />
        <button type='submit'>Enviar</button>
      </form>
    </div>
  );
}
